import 'angular';
import { CompanionClient } from '@amzn/aws-workdocs-web-companion-common';

export interface CompanionClientService {
    getClient: () => CompanionClient | undefined;
    setClient: (newClient: CompanionClient) => void;
}

angular.module('GorillaBoy')
.factory('CompanionClientService', [
    '$rootScope',
    function CompanionClientService($rootScope: ng.IRootScopeService) {
        let client: CompanionClient | undefined;
        const setClient = (newClient: CompanionClient) => {
            client = newClient;
        };
        const getClient = () => {
            return client;
        };
        return {
            getClient: getClient,
            setClient: setClient
        } as CompanionClientService;
    }
]);